import React from 'react'
// import ReactHtmlParser from 'react-html-parser'; 


import { getSizedImageUrl } from '../../../../../scripts/utils/image'

import { useSubBuilder } from '../../../../context/subBuilder/useSubBuilder'
import Price from '../../../Price';
import GreyBoxYellowBoxSwitcheroo from '../components/GreyBoxYellowBoxSwitcheroo';
import SubBuilderStep from '../components/SubBuilderStep';
// import Sticker from '../components/SubBuilderSticker';

const Duration: React.FunctionComponent = () => {
  const { settings, actions, getters, state } = useSubBuilder()
  // const variants = state.subscriptionType === 'me' ? getters.getPossibleVariants() : null
  const products = getters.getGiftProducts();
  // const quantities = settings.steps.quantity.options.map(({ quantity }) => quantity)
  // const [min, max] = [Math.min(...quantities), Math.max(...quantities)]
  if (state.subscriptionType === 'me') {
    console.error('Duration is only for gift products')
    return null
  }
  return (
    <SubBuilderStep className="sub-builder-duration" index={4} stepConfig={settings.steps.duration}>
      { products.map(({ handle, title, price, compare_at_price, price_varies, price_min }, i) => (
        <button className="sub-builder-btn sub-builder-btn-duration" id={`sub-builder-btn-duration-${i}`} key={handle} type="button" onClick={() => {
          actions.setDurationForGift(handle)
          actions.moveStep(+1)
        }}>
          <GreyBoxYellowBoxSwitcheroo className="sub-builder-btn-img sub-builder-btn-duration-img">
            { settings.steps.duration.options[i]?.image && <img src={getSizedImageUrl(/* The product blocks have to be in order */ settings.steps.duration.options[i].image, '300x300')} data-lazy-load /> }
          </GreyBoxYellowBoxSwitcheroo>
          <span className="sub-builder-btn-title">{title}</span>
          <Price
            finalPrice={price}
            originalPrice={compare_at_price ? compare_at_price : price}
            priceVaries={Boolean(price_varies)}
            priceMin={ price_min ? price_min : price }
          />
        </button>
      )) }
    </SubBuilderStep>)

}
export default Duration
